import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { SITE } from "../data/site";
import { PRODUCTS } from "../data/products";
import { useLang } from "../i18n";
import { Logo } from "./Navbar";
import { CatalogueButton } from "./CatalogueButton";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-sm">{t("footer.blurb")}</p>
          <p className="mt-6 font-heading font-black uppercase tracking-tight text-2xl text-white">
            {t("hero.l1")} {t("hero.l2")} <span className="text-silver">{t("hero.l3")}</span>
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-heading text-xs font-bold uppercase tracking-[0.3em] text-silver mb-6">{t("footer.products")}</h4>
          <ul className="space-y-3">
            {PRODUCTS.slice(0, 6).map((p) => (
              <li key={p.slug}>
                <Link to={`/products/${p.slug}`} data-testid={`footer-product-${p.slug}`}
                      className="text-sm text-white/70 hover:text-white transition-colors duration-200">
                  {p.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/products" data-testid="footer-all-products-link" className="text-sm text-silver hover:text-white transition-colors duration-200">
                {t("hl.all")}
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-heading text-xs font-bold uppercase tracking-[0.3em] text-silver mb-6">{t("footer.contact")}</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-silver" />
              <span>{SITE.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 shrink-0 text-silver" />
              <span>
                <a href={SITE.phone1Href} data-testid="footer-phone-1" className="hover:text-white transition-colors duration-200 block">{SITE.phone1}</a>
                <a href={SITE.phone2Href} data-testid="footer-phone-2" className="hover:text-white transition-colors duration-200 block">{SITE.phone2}</a>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 shrink-0 text-silver" />
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-white transition-colors duration-200">{SITE.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} className="mt-0.5 shrink-0 text-silver" />
              <span>{SITE.hours}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Sana Steel Industries. {t("footer.rights")}</span>
          <CatalogueButton testId="footer-download-catalogue" className="!text-white/60 hover:!text-white" />
          <a href={SITE.googleReview} target="_blank" rel="noreferrer" data-testid="footer-google-review"
             className="inline-flex items-center gap-1.5 font-heading text-xs font-bold uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors duration-200">
            <Star size={14} /> {t("review.google")}
          </a>
          <span>sanasteelindustries.in · Bengaluru, Karnataka</span>
        </div>
      </div>
    </footer>
  );
};
